<template>
  <section
    id="_tlqn_admin_user_group_list"
    class="bg-grey-1 q-pa-md column relative-position"
  >
    <!-- 搜索 -->
    <q-input v-model="search" dense filled label="搜索">
      <template v-slot:append>
        <q-icon name="fas fa-search" size="12px" />
      </template>
    </q-input>

    <q-scroll-area class="col-grow column q-my-md">
      <!-- loading -->
      <Loading v-if="loading" class="q-mt-xl" />
      <q-list v-else-if="filteredGroups.length" class="q-px-sm">
        <q-item
          style="min-height: 42px !important;"
          v-for="group in filteredGroups"
          :key="group.id"
          :title="group.description"
          clickable
          class="row items-center admin-group-li q-mb-sm"
          :to="{
            query: {
              _ug: group.id,
            },
          }"
          :class="{
            'admin-group-li-active': group.id === $route.query._ug,
          }"
        >
          <span class="ellipsis">
            {{ group.name }}
          </span>
        </q-item>
      </q-list>

      <Empty class="q-mt-xl" v-else />
    </q-scroll-area>

    <q-btn
      @click="showCreateGroupDialog = true"
      flat
      class="bg-primary text-white shadow-2"
      :disable="showCreateGroupDialog"
    >
      <q-icon name="fas fa-plus-circle" size="12px" class="q-mr-sm" />
      <span>新建小组</span>
    </q-btn>

    <!-- 新建 -->
    <q-dialog persistent v-model="showCreateGroupDialog">
      <CreateGroupForm
        @cancel="() => (showCreateGroupDialog = false)"
        @beforeCreate="loading = true"
        @error="loading = false"
        @created="fetchUserGroupList()"
      />
    </q-dialog>

    <LockMask
      v-if="adminStatusStore[REMOVING_GROUP_MEMBERS]"
      lock-tip="正在操作分组内的用户列表"
    />
  </section>
</template>

<script>
import { getGroupList } from "@/api/endpoints/group/getGroupList";
import { EventBus } from "@/bus/index";
import { GROUP_DETAIL_CHANGED } from "@/bus/admin.events";
import { REMOVING_GROUP_MEMBERS } from "@/status/admin.status";
import AdminCommonStatus from "@/views/Admin/mixins/status.mixin";
// adminStatusStore[REMOVING_GROUP_MEMBERS]
export default {
  mixins: [AdminCommonStatus],
  components: {
    LockMask: () => import("@/components/Mask"),
    Empty: () => import("@/components/Empty"),
    Loading: () => import("@/components/Loading"),
    CreateGroupForm: () => import("./CreateGroupForm"),
  },
  data() {
    return {
      loading: true,
      search: "",
      groups: [],
      showCreateGroupDialog: false,
      REMOVING_GROUP_MEMBERS,
    };
  },

  computed: {
    filteredGroups() {
      const { groups, search } = this;
      return groups.filter((g) => g.name.indexOf(search) > -1);
    },
  },

  mounted() {
    this.fetchUserGroupList();
    EventBus.$on(GROUP_DETAIL_CHANGED, this.fetchUserGroupList);
  },

  beforeDestroy() {
    EventBus.$off(GROUP_DETAIL_CHANGED, this.fetchUserGroupList);
  },

  methods: {
    /**
     * 获取用户分组
     */
    async fetchUserGroupList() {
      this.loading = true;
      try {
        const res = await getGroupList();
        if (res.status || res.error) {
          this.$q.notfiy({
            type: "danger",
            message: "获取用户列表出现错误, " + (res.detail || res.message),
          });
        } else {
          this.groups = res;
          if (!this.$route.query._ug) this.selectDefault();
        }
      } catch (err) {
        console.log(err);
        this.$q.notify({
          type: "danger",
          message: "获取用户分组时出现未知错误",
        });
      } finally {
        this.loading = false;
      }
    },

    async selectDefault() {
      if (!this.groups || !this.groups.length) return;
      this.$router.replace({ query: { _ug: this.groups[0].id } });
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/quasar";

#_tlqn_admin_user_group_list {
  .scroll {
    flex-grow: 1;
  }
}
.admin-group-li {
  color: #000 !important;
}
.admin-group-li-active {
  color: $primary !important;
  font-weight: bold;
  background-color: #fff;
  box-shadow: $shadow-1;
}
</style>
